import { render, staticRenderFns } from "./ChatThreadsBar.vue?vue&type=template&id=776e6080"
import script from "./ChatThreadsBar.vue?vue&type=script&lang=js"
export * from "./ChatThreadsBar.vue?vue&type=script&lang=js"
import style0 from "./ChatThreadsBar.vue?vue&type=style&index=0&id=776e6080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports